export class FilterOperator {
    Code: string;
    Name: string;
}